import FullScreenSvg from '../../../assets/icons/FullScreenSvg';
import theme from '../../../assets/theme';
import { IconWrapper } from '../IconWrapper';

const FullScreenHoverNudge = ({
  handleMouseDown,
  isHovering,
  isHiding,
}: {
  handleMouseDown: () => void;
  isHovering: boolean;
  isHiding: boolean;
}) => {
  return (
    <IconWrapper
      onMouseDown={() => {
        handleMouseDown();
      }}
      style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        backgroundColor: theme.colors.greyLight,
        padding: '5px',
        borderRadius: '10px',
        transform: 'translate(-50%, -50%)',
        opacity: 0.9,
        display: isHovering && !isHiding ? 'block' : 'none',
        height: 30,
        width: 30,
      }}
      color={theme.colors.black}
      height={'20px'}
      width={'20px'}
    >
      <FullScreenSvg />
    </IconWrapper>
  );
};

export default FullScreenHoverNudge;
